
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { ColorMixin, BARatingMixin, BAIconsMixin } from '@/mixins'
import { BARatingProfileModel } from '@/models/athlete/BARatingProfileModel'
import { BARatingFormula } from '@/models'
import { athleteApi } from '@/api/AthleteApi';

@Component
export default class BARatingChip extends Mixins(ColorMixin, BAIconsMixin, BARatingMixin) {
    @Prop({ required: true }) baRating: BARatingProfileModel;
    @Prop({ required: true }) formula: BARatingFormula;
    @Prop({ type: Boolean }) small;
    @Prop({ type: Boolean }) large;
    @Prop({ type: Boolean }) dense;
    @Prop({ type: Boolean }) loading;

    get isXL(): boolean {
        return !this.small && !this.large;
    }
    get AthleteName(): string {
        if( this.IsEmpty(this.baRating) ) return '--';
        return this.baRating.FullName;
    }
	get AthleteBARatingStr(): string {
        if( this.IsEmpty(this.baRating) ) return '--';
		return this.baRating.Rating;
	}
	get RatingColor(): string {
		if( this.IsEmpty(this.baRating) ) return 'primary';
        if( this.IsEmpty(this.formula?.levelsSorted) ) return 'primary';

		for( const level of this.formula.levelsSorted ) {
			if( this.baRating.rating >= level.floor ) return level.color;
		}
		return 'primary';
	}
	get RatingTextColor(): string {
		return this.ComplementaryTextColor(this.RatingColor);
	}

    isViewingDetails: boolean = false;
    onViewDetails() {
        this.isViewingDetails = true;
    }
    onHideDetails() {
        this.isViewingDetails = false;
    }

    isViewingOverall: boolean = false;
    onClickOverall() {
        this.isViewingOverall = true;
        this.backupIntangibles = this.baRating.athleteProfile.intangibles;
    }

    isChangedIntangibles: boolean = false;
    backupIntangibles: number;
    onChangeIntangibles() {
        this.isChangedIntangibles = true;
    }
    onCancelIntangibles() {
        this.baRating.athleteProfile.intangibles = this.backupIntangibles;
        this.isChangedIntangibles = false;
        this.isViewingOverall = false;
    }
    async onAcceptIntangibles() {
        await athleteApi.patch({id: this.baRating.athleteProfile.id, intangibles: this.baRating.athleteProfile.intangibles})
        this.isChangedIntangibles = false;
        this.isViewingOverall = false;
    }
}
